import { IProgressIndicatorStyles, concatStyleSets, FontWeights } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../pages/common.styles';

export const getAppProgressBarStyles = (customStyles?: Partial<IProgressIndicatorStyles>): IProgressIndicatorStyles => {
  const styles: IProgressIndicatorStyles = {
    root: {
      width: '100%'
    },
    itemDescription: {
      color: AppLayoutSettings.AppColors.mediumLabelColor,
      fontSize: AppLayoutSettings.AppFontSize.mediumFontSizePx
    },
    itemName: {
      fontWeight: FontWeights.semibold,
      fontSize: AppLayoutSettings.AppFontSize.largeFontSizePx
    },
    itemProgress: {},
    progressBar: {
      background: AppLayoutSettings.AppColors.primaryWidgetColor,
      selectors: {
        ['@media screen and (-ms-high-contrast: active)']: {
          MsHighContrastAdjust: 'none',
          background:'window'
        }
      }
    },
    progressTrack: {
      background: AppLayoutSettings.AppColors.darkBackgroundColor,
      selectors: {
        ['@media screen and (-ms-high-contrast: active)']: {
          MsHighContrastAdjust: 'none',
          background:'highlight'
        }
      }
    }
  };

  return concatStyleSets(styles, customStyles);
};
